<div class="loader app-loader proj-section" [hidden]="status != LOADING">
  <div class="dimmed_outset">
    <core-title-section [title]="'PROJECT <small>(# . . .)</small>'"></core-title-section>
  </div>
  <div class="dimmed dimmed_main">
    <div class="dimmed_nav">
      <div class="dimmed_subtitle"></div>
      <div class="dimmed_subtitle"></div>
      <div class="dimmed_subtitle"></div>
    </div>
    <div class="dimmed_content">
      <div class="dimmed_flex">
        <span class="dimmed_tag"></span>
        <span class="dimmed_tag"></span>
        <span class="dimmed_tag"></span>
      </div>
    </div>
  </div>
</div>
<core-helpers-box-http-error
  [hidden]="status != NOT_FOUND"
  [code]="404"
  [message]="'Not found. Check your URL.'"
></core-helpers-box-http-error>

<div class="app-wrapper" *ngIf="status == DONE">
  <nav class="tab_navigation"></nav>
  <section class="main-content bridges-filecomparison-project-section request-content">
    <div class="app-main">
      <div class="request-main">
        <core-projects-breadcrumb-header *ngIf="project != null  || partialProject != null" [project]="project ?? partialProject" [title]="breadcrumbText"
          [breadcrumbs]="breadcrumbs"></core-projects-breadcrumb-header>
        <ng-container *ngIf="project != null || partialProject != null; else noAccessToProject">
          <div class="sub-header">
            <div>
              <h3>File comparison</h3>
              <p>Here you can select the files to compare</p>
            </div>
            <div [hidden]="!files.isComplete()">
              <div class="fieldset-buttons">
                <core-helpers-forms-button
                [type]="'grey'"
                [text]="'Cancel'"
                (submit)="cancel()"
                ></core-helpers-forms-button>
                <core-helpers-forms-button-white
                [text]="'Compare'"
                (submit)="goToCompare()"
                ></core-helpers-forms-button-white>
              </div>
            </div>
          </div>

          <div class="two-boxes-plugin request-compare-files">
            <div>

              <core-files-selected-box
                [title]="'YOUR REFERENCE'"
                [files]="files.reference? [files.reference] : []"
                [buttonAction]="files.isComplete()"
                [buttonActionText]="'CHANGE ORDER'"
                (onButtonActionClick)="files.changeOrder()"
                (onFileActionClick)="files.remove('reference')"
              ></core-files-selected-box>
            </div>
            <div>
              <core-files-selected-box
                [title]="'YOUR TARGET'"
                [files]="files.target? [files.target] : []"
                (onFileActionClick)="files.remove('target')"
              ></core-files-selected-box>
            </div>
          </div>

          <h4 class="h4_subtitle">Select the files to compare from the list below</h4>

          <core-commons-files-list-checkbox
            *ngIf="project != null"
            [url]="filesUrl"
            [counterPluralTitle]="'attachments'"
            [counterSingularTitle]="'attachment'"
            [selected]="files.selected"
            (selectedChange)="onChange($event);"
            [disabled] = "files.isComplete()"
          ></core-commons-files-list-checkbox>

          <core-versions-related-selector
            *ngIf="project != null || partialProject != null"
            [project]="project ?? partialProject"
            [selected]="files.selected"
            (selectedChange)="onChange($event);"
            [disabled]="files.isComplete()"
          ></core-versions-related-selector>

          <core-version-origin-version-files-list-checkbox
            [request]="project"
            [selected]="files.selected"
            (selectedChange)="onChange($event);"
            [disabled]="files.isComplete()">
          </core-version-origin-version-files-list-checkbox>

        </ng-container>
        <ng-template #noAccessToProject>
          <core-helpers-box-alert-message-icon
            [text]="'You do not have permission to access this project.'"
            [icon]="'warning'">
          </core-helpers-box-alert-message-icon>
        </ng-template>
      </div>
    </div>
  </section>
</div>
